import React, { useState } from 'react';
import { Lock, Eye, EyeOff, RefreshCw } from 'lucide-react';

const ADMIN_PASSWORD = '123456789M';
const AUTH_KEY = 'tasdemir_admin_auth';

const AdminLogin = ({ onLogin }) => {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === ADMIN_PASSWORD) {
      localStorage.setItem(AUTH_KEY, 'true');
      onLogin();
    } else {
      setError('Hatalı şifre!');
    }
  };

  const handleResetData = () => {
    if (window.confirm('Tüm site verileri sıfırlanacak. Emin misiniz?')) {
      localStorage.removeItem('tasdemir_insaat_data');
      localStorage.removeItem(AUTH_KEY);
      window.location.reload();
    }
  };

  return (
    <div className="min-h-screen bg-anthracite flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="bg-anthracite-light rounded-lg border border-gold/20 p-8">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-gold/10 rounded-full mb-4">
              <Lock className="w-8 h-8 text-gold" />
            </div>
            <h1 className="text-2xl font-bold text-white">Admin Paneli</h1>
            <p className="text-gray-400 mt-2">Devam etmek için giriş yapın</p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="mb-6">
              <label className="block text-sm text-gray-400 mb-2">Şifre</label>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setError('');
                  }}
                  className="w-full px-4 py-3 bg-anthracite border border-gold/20 rounded text-white focus:border-gold focus:outline-none transition-colors duration-300"
                  placeholder="Şifrenizi girin"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gold"
                >
                  {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                </button>
              </div>
              {error && <p className="text-red-400 text-sm mt-2">{error}</p>}
            </div>

            <button
              type="submit"
              className="w-full py-3 bg-gold text-anthracite font-semibold rounded hover:bg-gold-light transition-colors duration-300"
            >
              Giriş Yap
            </button>
          </form>

          <div className="mt-6 pt-6 border-t border-gold/10">
            <button
              onClick={handleResetData}
              className="w-full flex items-center justify-center space-x-2 py-2 text-gray-400 hover:text-gold text-sm transition-colors duration-300"
            >
              <RefreshCw className="w-4 h-4" />
              <span>Verileri Sıfırla (Sorun yaşıyorsanız)</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
export { AUTH_KEY };